





































































































































































































































import { Vue, Component, Prop, Watch } from "../vue-ext";
// import Vue from "vue";
// import Component from "vue-class-component";
// import { Watch, Prop } from "vue-property-decorator";

import {
    DateString,
    TransportLoad,
    TransportLoadTask,
    TransportVehicle,
} from "@/models";

import {
    transportLoadService,
    transportLoadActionService
} from "@/services";

import PlanTaskDialogLoadTask from "../components/PlanTaskDialogLoadTask.vue";
import PlanTaskDialogPartyAddress from "../components/PlanTaskDialogPartyAddress.vue";
import PlanTaskLoadTransportPartsDialog from "../components/PlanTaskLoadTransportPartsDialog.vue";

import VehicleCalendar from "../components/VehicleCalendar.vue";
import VehicleSelectDialog from "../components/VehicleSelectDialog.vue";
import taskStateColors from "../taskstates";

@Component({
    components: {
        PlanTaskDialogLoadTask,
        PlanTaskDialogPartyAddress,
        PlanTaskLoadTransportPartsDialog,
        VehicleCalendar,
        VehicleSelectDialog
    }
})
export default class PlanTaskDialog extends Vue {
    @Prop() value!: null | { load: TransportLoad; loadTask: TransportLoadTask };
    @Prop() defaultvehicle!: TransportVehicle;
    @Prop() favoriteVehiclesOnly!: boolean;

    panels = [1];

    taskStateColors = taskStateColors;

    loading = false;
    saving = false;
    state = "";
    targetLoad: null | TransportLoad = null;
    targetLoadTaskIndex: number = 0;

    vehicle: null | TransportVehicle = null;
    showVehicleDialog = false;

    date: DateString = new Date().toISOString().split("T")[0];
    showDateDialog = false;

    loads: null | TransportLoad[] = null;
    selectedLoad: null | { load: TransportLoad; loadTask: TransportLoadTask } = null;

    modalTransportParts: TransportLoad | null = null;

    required(value: any) {
        return !!value || this.$t("validationErrors.required");
    }

    async created() {
        this.vehicle = this.defaultvehicle;
    }

    async mounted() {
        await this.loadVehicleLoads();
    }

    async loadVehicleLoads() {
        if (this.loading) {
            return;
        }
        // TODO cancel
        this.loads = [];
        if (!this.date || isNaN(Date.parse(this.date))) {
            this.date = new Date().toISOString().split("T")[0];
        }
        if (!this.vehicle || !this.date) {
            return;
        }
        this.loading = true;
        this.loads = (
            await transportLoadService.searchLoads({
                vehicleId: [this.vehicle.vehicleId],
                targetDate: this.date,
                loadState: [ "New" ]
            })
        ).items;
        // Remove current load from load list
        if (this.value) {
            const loadId = this.value.load.loadId;
            this.loads = this.loads.filter(i => i.loadId !== loadId);
        }
        // Reset adding to load
        if (this.addingToOldLoad) {
            this.removeSelection();
        }
        this.loading = false;
    }

    async reload() {
        await this.loadVehicleLoads();
    }

    async setVehicle(vehicle: null | TransportVehicle) {
        if (!vehicle && !this.vehicle || vehicle && this.vehicle && vehicle.vehicleId === this.vehicle.vehicleId) {
            return;
        }
        this.vehicle = vehicle;
        this.showVehicleDialog = !vehicle;
        await this.loadVehicleLoads();
    }

    async setDate(date: null | string) {
        if (!date && !this.date || date && this.date && date === this.date) {
            return;
        }
        date = date || "";
        this.date = date;
        this.showDateDialog = !date;
        await this.loadVehicleLoads();
    }

    hasLoadAlert(load: TransportLoad) {
        return (
            load.loadState !== "Done" &&
            !load.loadTasks.find(lt => lt.task && lt.task.state !== "Ready")
        );
    }

    select(value: { load: TransportLoad, loadTask: TransportLoadTask }) {
        this.selectedLoad = value;
    }

    removeSelection() {
        this.state = "";
        this.targetLoad = null;
        this.targetLoadTaskIndex = 0;
    }

    createNewLoad(value: null | { load: TransportLoad; loadTask: TransportLoadTask }) {
        this.state = "createNewLoad";
        this.targetLoad = null;
        this.targetLoadTaskIndex = 0;
    }

    addToLoad(load: TransportLoad) {
        this.state = "addToLoad";
        this.targetLoad = load;
        this.targetLoadTaskIndex = load.loadTasks.length ? load.loadTasks.length : -1;
    }

    get creatingNewLoad() {
        return this.state === "createNewLoad";
    }

    get addingToOldLoad() {
        return this.state === "addToLoad" && !!this.targetLoad;
    }

    async moveTaskUp() {
        if (!this.targetLoad || !this.targetLoad.loadTasks.length || this.targetLoadTaskIndex < 1) {
            return;
        }
        this.targetLoadTaskIndex = this.targetLoadTaskIndex - 1;
    }

    async moveTaskDown() {
        if (!this.targetLoad || !this.targetLoad.loadTasks.length || this.targetLoadTaskIndex > this.targetLoad.loadTasks.length - 1) {
            return;
        }
        this.targetLoadTaskIndex = this.targetLoadTaskIndex + 1;
    }

    get canSave() {
        if (!this.state || !this.vehicle || !this.date || !this.value) {
            return false;
        }
        if (this.state === "addToLoad" && !this.targetLoad) {
            return false;
        }
        return true;
    }

    async save() {
        if (!this.vehicle || !this.date || !this.value) {
            return;
        }
        if (!this.creatingNewLoad && !this.addingToOldLoad) {
            return;
        }
        // Remove old load
        this.saving = true;
        const taskId = this.value.loadTask.task.taskId;
        await transportLoadActionService.deleteLoadTask(this.value.load.loadId, this.value.loadTask.loadTaskId);
        // Create new load
        if (this.creatingNewLoad) {
            const newLoad = await transportLoadActionService.createLoad({
                vehicleId: this.vehicle.vehicleId,
                date: this.date,
                taskId: [taskId],
                updatePlanner: false,
            });
            // TODO Assing TransportParts/Kuljetusnimikkeet
            this.saving = false;
            this.modalTransportParts = newLoad;

        // Create add to existing load
        } else if (this.addingToOldLoad && this.targetLoad) {
            const data = await transportLoadActionService.createLoadTask(this.targetLoad.loadId, {
                taskId: [taskId],
                transition: null as any,
                orderNumber: this.targetLoad.loadTasks.length && this.targetLoadTaskIndex > 0
                    ? (this.targetLoadTaskIndex < this.targetLoad.loadTasks.length
                        ? this.targetLoad.loadTasks[this.targetLoadTaskIndex].orderNumber
                        : this.targetLoad.loadTasks[this.targetLoad.loadTasks.length - 1].orderNumber + 1)
                    : 0,
                updatePlanner: false,
            });
            this.saving = false;
            this.$emit("saveAndClose");
        }
    }

    closeTransportPartsDialog() {
        this.modalTransportParts = null;
        this.$emit("saveAndClose");
    }
}
